import { render, staticRenderFns } from "./AccountLimitationForMoreMonitorRefreshNotification.vue?vue&type=template&id=51558d82&"
import script from "./AccountLimitationForMoreMonitorRefreshNotification.vue?vue&type=script&lang=js&"
export * from "./AccountLimitationForMoreMonitorRefreshNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AccountLimitationForMoreMonitorRefreshNotification.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
